import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../common/PageLayout';
import '../css/Step1.css';
import { handleFileDownload } from '../utils/fileHandlers/downloadHandler';
import { LocalizationXlsxExport } from '../utils/api/productApi';

const TranslationXlsxExport = () => {
  const [error, setError] = useState(null);
  const [statusMessage, setStatusMessage] = useState('waiting...');
  const [isImporting, setIsImporting] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [animatedText, setAnimatedText] = useState('Download JP Localization Data Xlsx');

  useEffect(() => {
    // 기존 텍스트 애니메이션 로직 유지
    if (isImporting) {
      let currentIndex = 0;
      const fullText = 'Downloading JP Localization Data Xlsx';
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;
        if (currentIndex === fullText.length) currentIndex = 0;
      }, 150);
      return () => clearInterval(timer);
    }
  }, [isImporting]);
  // 개별 다운로드 처리 함수
  const handleDownloadProcess = async (apiFunction, description) => {
    try {
      setStatusMessage(`Downloading ${description}...`);
      const apiResponse = await apiFunction();

      if (!apiResponse.success) {
        throw apiResponse.error;
      }

      const downloadResult = await handleFileDownload(apiResponse);
      setStatusMessage(downloadResult.message);

      return downloadResult.success;
    } catch (error) {
      console.error(`Error downloading ${description}:`, error);
      throw error; // 상위 함수에서 처리하도록 에러를 전파
    }
  };

  // 메인 제출 함수
  const handleSubmit = async (formData) => {
    setError("");
    setIsImporting(true);
    console.log("extract jp localization data xlsx handleSubmit");
    try {
      // 순차적으로 다운로드 처리
      const downloads = [
        { fn: () => LocalizationXlsxExport(formData), description: 'Extract JP Localization Data' },
      ];

      for (const download of downloads) {
        const success = await handleDownloadProcess(download.fn, download.description);

        if (!success) {
          setStatusMessage(`Failed to download ${download.description}`);
          return;
        }
      }

      setStatusMessage("All files downloaded successfully.");
      setIsFinished(true);
    } catch (error) {
      console.error('Error:', error);
      setError('Error occurred during download process.');
      setStatusMessage('Download failed.');
    } finally {
      setIsImporting(false);
    }
  };

  const validateFile = (file) => {
    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel"
    ];
    return validTypes.includes(file.type);
  };

  return (
    <PageLayout
      title="Export JP Localization Data to Xlsx"
      submitButtonText="Download JP Localization Data"
      description={
        <p className={`animated-text ${isImporting ? 'importing' : ''}`}>
          {animatedText}
        </p>
      }
      onSubmit={handleSubmit}
      isFileUpload={false}
      validateFile={validateFile}
      error={error}
      statusMessage={statusMessage}
      multiple={true}
      acceptTypes=".xlsx,.xls"
    >
    </PageLayout>
  );
};

export default TranslationXlsxExport;